module.exports = __webpack_public_path__ + "img/DS-mob.c8b3e765.jpg";